import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import ListVoucherCodeContainer from 'app/containers/Marketing/VoucherManagement/ListVoucherCode'

const ListVoucherCodePageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.voucher_code_list)}</PageTitle>
      <ListVoucherCodeContainer />
    </>
  )
}
const ListVoucherCodePage = memo(ListVoucherCodePageCpn, isEqual)

export default ListVoucherCodePage
